import styled from "styled-components";

export const StyledHomeBackendSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 28px;

  .backend-section {
    width: 100%;
  }

  .backend-section-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 14px;
  }

  .backend-section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .backend-section-icon {
    width: 22px;
    height: 22px;
    flex: 0 0 auto;
    color: var(--crypto-green);
    filter: drop-shadow(var(--crypto-green-glow) 0 0 5px);
  }

  .backend-section-icon *:not([fill="none"]) {
    fill: currentColor;
  }

  .popular-play-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 1;
  }

  .backend-section-name {
    color: #ffffff;
    font-size: 17px;
    line-height: 1.25;
    font-weight: 700;
  }

  .backend-section-actions {
    display: flex;
    align-items: center;
    gap: 7px;
    flex: 0 0 auto;
  }

  .view-all-link {
    color: var(--crypto-green);
    font-size: 13px;
    line-height: 1;
    padding-right: 3px;
  }

  .view-all-link:hover {
    text-decoration: underline;
  }

  .backend-section-actions button {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: rgba(166, 196, 213, 0.12);
    color: #ffffff;
    font-size: 24px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, color 0.15s ease;
  }

  .backend-section-actions button:hover {
    background: var(--crypto-green-soft);
    color: var(--crypto-green);
  }

  .backend-card-rail {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 150px;
    gap: 12px;
    overflow: auto hidden;
    scroll-snap-type: x proximity;
    padding: 14px 2px 14px;
    scrollbar-width: none;
  }

  .backend-card-rail::-webkit-scrollbar {
    display: none;
  }

  .backend-card-rail.is-auto-rail {
    scroll-snap-type: none;
  }

  @keyframes backend-event-rail-loop {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      transform: translate3d(var(--event-loop-distance), 0, 0);
    }
  }

  .backend-section-events
    .backend-card-rail.is-auto-rail[data-auto-scroll-ready="true"]
    > * {
    animation: backend-event-rail-loop var(--event-loop-duration) linear infinite;
  }

  .backend-section-events .backend-card-rail.is-auto-rail:hover > *,
  .backend-section-events .backend-card-rail.is-auto-rail:focus-within > *,
  .backend-section-events
    .backend-card-rail.is-auto-rail[data-auto-scroll-paused="true"]
    > * {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    .backend-section-events
      .backend-card-rail.is-auto-rail[data-auto-scroll-ready="true"]
      > * {
      animation: none;
      transform: none;
    }
  }

  &.home-recent-play-wrapper {
    margin-top: 26px;
    margin-bottom: 2px;
  }

  .recent-play-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #a9c5d6;
    color: #12303c;
    filter: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 -1px 0 rgba(6, 22, 29, 0.16);
  }

  .recent-play-icon svg {
    width: 16px;
    height: 16px;
    display: block;
    fill: none;
    stroke: currentColor;
    stroke-width: 2.9;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .recent-play-rail {
    grid-auto-columns: 150px;
    padding-top: 10px;
  }

  .recent-play-card-wrap {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }

  .recent-play-meta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #b8c7d3;
    font-size: 13px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .live-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: #24e75e;
    box-shadow: 0 0 8px rgba(36, 231, 94, 0.45);
  }

  .backend-card-link {
    display: block;
    min-width: 0;
    color: inherit;
    text-decoration: none;
    scroll-snap-align: start;
  }

  .backend-card-shell {
    position: relative;
    width: 150px;
    min-width: 0;
    scroll-snap-align: start;
  }

  .backend-card-shell .backend-card-link {
    width: 100%;
    scroll-snap-align: none;
  }

  .backend-card-button {
    appearance: none;
    border: 0;
    background: transparent;
    padding: 0;
    text-align: inherit;
    font: inherit;
    cursor: pointer;
  }

  .favorite-toggle {
    position: absolute;
    z-index: 8;
    top: 8px;
    right: 8px;
    width: 31px;
    height: 31px;
    border: 1px solid rgba(166, 196, 213, 0.22);
    border-radius: 50%;
    background: rgba(6, 18, 24, 0.78);
    color: rgba(224, 236, 244, 0.9);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28);
    opacity: 0.92;
    transform: translateY(0) scale(1);
    transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease,
      border-color 0.18s ease, box-shadow 0.18s ease;
  }

  .favorite-toggle span {
    display: block;
    font-size: 17px;
    line-height: 1;
    transform: translateY(-1px);
  }

  .favorite-toggle:hover,
  .favorite-toggle:focus-visible {
    color: #ffffff;
    border-color: rgba(89, 244, 119, 0.48);
    background: rgba(18, 66, 39, 0.92);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.34), 0 0 14px rgba(89, 244, 119, 0.2);
    transform: translateY(-1px) scale(1.04);
    outline: 0;
  }

  .favorite-toggle.is-active {
    color: #07130c;
    border-color: rgba(89, 244, 119, 0.7);
    background: linear-gradient(135deg, #7cff91, #28d765);
  }

  .backend-card {
    position: relative;
    width: 150px;
    aspect-ratio: 5 / 7;
    overflow: hidden;
    border-radius: 8px;
    background:
      linear-gradient(160deg, rgba(89, 244, 119, 0.1), rgba(12, 32, 40, 0.88)),
      var(--crypto-surface-2);
    border: 0;
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
    scroll-snap-align: start;
    transform: translateY(0);
    transition: transform 0.24s ease, box-shadow 0.24s ease, filter 0.24s ease;
  }

  .backend-card-shell:hover .backend-card,
  .backend-card-link:hover .backend-card,
  .backend-card:hover {
    transform: translateY(-9px);
    box-shadow: 0 20px 34px rgba(0, 0, 0, 0.34), 0 0 20px rgba(89, 244, 119, 0.09);
  }

  .backend-card img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    background: var(--crypto-surface-3);
    transform: scale(1.01);
    transition: transform 0.28s ease, filter 0.28s ease;
  }

  .backend-card-shell:hover .backend-card img,
  .backend-card-link:hover .backend-card img,
  .backend-card:hover img {
    filter: blur(2px) brightness(0.58) saturate(1.12);
    transform: scale(1.07);
  }

  .vendor-card.no-image,
  .event-card.no-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .vendor-card.no-image::before,
  .event-card.no-image::before {
    content: "";
    position: absolute;
    inset: 13px;
    border-radius: 7px;
    border: 1px solid rgba(89, 244, 119, 0.14);
    background:
      radial-gradient(circle at 22% 18%, rgba(89, 244, 119, 0.2), transparent 32%),
      linear-gradient(135deg, rgba(255, 255, 255, 0.06), transparent);
  }

  .backend-card::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(180deg, rgba(9, 12, 18, 0.02) 22%, rgba(9, 12, 18, 0.18) 52%, rgba(6, 8, 12, 0.88) 100%);
    pointer-events: none;
    transition: opacity 0.24s ease;
  }

  .backend-card-shell:hover .backend-card::after,
  .backend-card-link:hover .backend-card::after,
  .backend-card:hover::after {
    opacity: 0.9;
  }

  .backend-card-title {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 22px;
    z-index: 2;
    padding: 0 12px;
    display: flex;
    justify-content: center;
    text-align: center;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .backend-card-title strong,
  .backend-card-hover-layer strong {
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 17px;
    line-height: 1.16;
    font-weight: 700;
    letter-spacing: 0;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.78), 0 0 14px rgba(255, 255, 255, 0.08);
    word-break: keep-all;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .no-image .backend-card-title {
    inset: 0;
    bottom: auto;
    align-items: center;
    text-align: center;
    padding: 16px;
  }

  .backend-card-shell:hover .backend-card-title,
  .backend-card-link:hover .backend-card-title,
  .backend-card:hover .backend-card-title {
    opacity: 0;
    transform: translateY(10px);
  }

  .backend-card-hover-layer {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 26px;
    padding: 22px 13px 24px;
    text-align: center;
    background: rgba(6, 18, 24, 0.2);
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.22s ease, transform 0.22s ease;
  }

  .backend-card-shell:hover .backend-card-hover-layer,
  .backend-card-link:hover .backend-card-hover-layer,
  .backend-card:hover .backend-card-hover-layer {
    opacity: 1;
    transform: translateY(0);
  }

  .backend-card-play {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #59f477, #16b857);
    box-shadow: 0 12px 26px rgba(22, 184, 87, 0.35), 0 0 20px rgba(89, 244, 119, 0.18),
      inset 0 1px 0 rgba(255, 255, 255, 0.42);
    transform: translateY(8px) scale(0.9);
    transition: transform 0.22s ease, box-shadow 0.22s ease;
  }

  .backend-card-play::before {
    content: "";
    width: 0;
    height: 0;
    margin-left: 4px;
    border-top: 11px solid transparent;
    border-bottom: 11px solid transparent;
    border-left: 16px solid #ffffff;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  }

  .backend-card-play.is-disabled {
    background: linear-gradient(135deg, #70798d, #3b4355);
    box-shadow: 0 12px 22px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.18);
  }

  .backend-card-shell:hover .backend-card-play,
  .backend-card-link:hover .backend-card-play,
  .backend-card:hover .backend-card-play {
    transform: translateY(0) scale(1);
    box-shadow: 0 14px 28px rgba(22, 184, 87, 0.42), 0 0 24px rgba(89, 244, 119, 0.24),
      inset 0 1px 0 rgba(255, 255, 255, 0.44);
  }

  .event-hover-layer {
    gap: 18px;
  }

  .event-card-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    min-width: 112px;
    padding: 0 17px;
    border-radius: 999px;
    color: #07130c;
    background: linear-gradient(135deg, #7cff91, #28d765 52%, #18a94b);
    box-shadow: 0 12px 24px rgba(22, 184, 87, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.48);
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: 0;
    transform: translateY(8px);
    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
  }

  .event-card-action::after {
    content: "›";
    margin-left: 8px;
    color: rgba(7, 19, 12, 0.78);
    font-size: 18px;
    line-height: 1;
    transform: translateY(-1px);
  }

  .backend-card-link:hover .event-card-action,
  .backend-card:hover .event-card-action {
    transform: translateY(0);
    filter: brightness(1.04);
    box-shadow: 0 15px 28px rgba(22, 184, 87, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  }

  .is-skeleton-rail {
    pointer-events: none;
  }

  .skeleton-card {
    box-shadow: none;
  }

  .skeleton-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.045),
      rgba(255, 255, 255, 0.11),
      rgba(255, 255, 255, 0.045)
    );
    background-size: 220% 100%;
    animation: cryptoSkeletonShimmer 1.35s ease-in-out infinite;
  }

  .skeleton-card::after {
    display: none;
  }

  .skeleton-title {
    position: absolute;
    left: 18px;
    right: 18px;
    bottom: 24px;
    z-index: 2;
    height: 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
  }

  .section-state {
    min-height: 88px;
    border-radius: 8px;
    border: 1px solid var(--crypto-border-soft);
    background: rgba(166, 196, 213, 0.045);
    color: var(--crypto-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 18px;
    font-size: 13px;
  }

  .section-state.error {
    color: #ff8f8f;
    border-color: rgba(255, 95, 95, 0.16);
    background: rgba(255, 95, 95, 0.05);
  }

  .backend-section-events .backend-card-rail {
    grid-auto-columns: clamp(300px, 30vw, 420px);
    gap: 16px;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .backend-section-events .backend-card {
    width: 100%;
    aspect-ratio: 4 / 3;
    border-radius: 10px;
    box-shadow: 0 14px 26px rgba(0, 0, 0, 0.24);
  }

  .backend-section-events .backend-card-title {
    bottom: 22px;
  }

  .backend-section-events .backend-card-title strong,
  .backend-section-events .backend-card-hover-layer strong {
    font-size: 23px;
    line-height: 1.14;
  }

  .event-empty-card {
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.12);
  }

  .event-empty-card .backend-card-title {
    inset: 0;
    bottom: auto;
    align-items: center;
    padding: 16px;
  }

  .event-empty-card .backend-card-title strong {
    color: #9097aa;
    font-size: 13px;
    line-height: 1.3;
    font-weight: 800;
    text-shadow: none;
  }

  .event-empty-card:hover {
    transform: translateY(0);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.12);
  }

  .event-empty-card:hover .backend-card-title {
    opacity: 1;
    transform: none;
  }

  @keyframes cryptoSkeletonShimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -120% 0;
    }
  }

  @media (max-width: 768px) {
    gap: 24px;
    margin-top: 22px;

    .backend-section-header {
      align-items: flex-start;
    }

    .backend-section-name {
      font-size: 16px;
    }

    .view-all-link {
      display: none;
    }

    .backend-section-actions button {
      width: 30px;
      height: 30px;
    }

    .backend-card-rail {
      grid-auto-columns: 136px;
      gap: 10px;
      padding-top: 13px;
      padding-bottom: 13px;
    }

    .backend-card {
      width: 136px;
    }

    .backend-card-shell {
      width: 136px;
    }

    .favorite-toggle {
      top: 7px;
      right: 7px;
      width: 29px;
      height: 29px;
    }

    .backend-card-title strong,
    .backend-card-hover-layer strong {
      font-size: 15px;
    }

    .event-empty-card .backend-card-title strong {
      font-size: 12px;
    }

    .backend-section-events .backend-card-rail {
      grid-auto-columns: min(86vw, 330px);
      gap: 12px;
      padding-top: 16px;
      padding-bottom: 16px;
    }

    .backend-section-events .backend-card-title strong,
    .backend-section-events .backend-card-hover-layer strong {
      font-size: 17px;
    }

    .backend-card-play {
      width: 52px;
      height: 52px;
    }

    .backend-card-play::before {
      border-top-width: 10px;
      border-bottom-width: 10px;
      border-left-width: 15px;
    }
  }
`;
